import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/propertyTypes/usePropertyTypesQueryKeys.ts
var t = e("propertyTypes", { list: (e) => ["list", e] });
//#endregion
export { t as propertyTypesQueryKeys };
